/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isinherited1Inputs */

const en_entity_isinherited1 = /** @type {(inputs: Entity_Isinherited1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Inherited`)
};

const de_entity_isinherited1 = /** @type {(inputs: Entity_Isinherited1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist vererbt`)
};

/**
* | output |
* | --- |
* | "Is Inherited" |
*
* @param {Entity_Isinherited1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isinherited1 = /** @type {((inputs?: Entity_Isinherited1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isinherited1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isinherited1(inputs)
	return de_entity_isinherited1(inputs)
});
export { entity_isinherited1 as "entity_isInherited" }